import { Alert, Avatar, Box, Button, Card, CircularProgress, Collapse, Divider, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Snackbar, Tab, Tabs, TextField, Typography } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react'
import { Postrequestcall } from '../../request/Postrequest';
import { FETCHPRODUCTDOCUMENTS, SAVE_USER_DOCUMENTS } from '../../constant/Apipath';
import { useSelector } from 'react-redux';
import { ArrowForwardIos, Close, CloudUpload, Description, ExpandLess, ExpandMore, FolderOpen, Image, InsertDriveFile, PictureAsPdf, Refresh, VideoFile } from '@mui/icons-material';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Fileuploadrequestcall } from '../../request/Fileuploadrequest';
import ProductDocumentDetailModal from './ProductDocumentDetailModal';
import { English } from '../../constant/EnglishFallback';

export default function ProductDocumentSection({ id, scrollId, color = "" }) {
    const { loginData, multiLanguageData } = useSelector((state) => state?.main);
    const currentUserId = loginData?.userInformation?.UserId ?? 0;
    const accentColor = color || '#1976d2';
    const PAGE_SIZE = 10;

    const [selectedFile, setSelectedFile] = useState(null);
    const [fileDescription, setFileDescription] = useState('');
    const [isExpanded, setIsExpanded] = useState(true);
    const [isUploading, setIsUploading] = useState(false);
    const [showDescriptionError, setShowDescriptionError] = useState(false);
    const [documents, setDocuments] = useState([]);
    const [allDocuments, setAllDocuments] = useState([]);
    const [nrOfRecords, setNrOfRecords] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [selectedFilter, setSelectedFilter] = useState(0); // 0 for 'recent', 1 for 'all'
    const [isTabSwitching, setIsTabSwitching] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const [selectedFileDetails, setSelectedFileDetails] = useState(null);
    const [fileDetailsModalOpen, setFileDetailsModalOpen] = useState(false);

    const LanguageData = multiLanguageData?.Products || {};
    const {
        TEXT_UPLOAD_FILE = English.Products.TEXT_UPLOAD_FILE,
        TEXT_CHOOSE_FILE = English.Products.TEXT_CHOOSE_FILE,
        TEXT_ADD_DESC_PLACEHOLDER = English.Products.TEXT_ADD_DESC_PLACEHOLDER,
        TEXT_UPLOADING = English.Products.TEXT_UPLOADING,
        TEXT_DOCEMENTS = English.Products.TEXT_DOCEMENTS,
        TEXT_RECENTS = English.Products.TEXT_RECENTS,
        TEXT_TECHNICAL_DOCUMENTS = English.Products.TEXT_TECHNICAL_DOCUMENTS,
        TEXT_LOADING_DOCEMENTS = English.Products.TEXT_LOADING_DOCEMENTS,
        TEXT_NO_DOCUMENTS = English.Products.TEXT_NO_DOCUMENTS,
        TEXT_UPLOAD_DOCUMENTS_PLACEHOLDER = English.Products.TEXT_UPLOAD_DOCUMENTS_PLACEHOLDER,
        TEXT_LOADING_MORE_DOCEMENTS = English.Products.TEXT_LOADING_MORE_DOCEMENTS,
        TEXT_FILE_SAVED_SUCCESS = English.Products.TEXT_FILE_SAVED_SUCCESS,
        TEXT_FAILED_TO_SAVE_FILE = English.Products.TEXT_FAILED_TO_SAVE_FILE,
        TEXT_PLEASE_SELECT_FILE = English.Products.TEXT_PLEASE_SELECT_FILE,
        TEXT_ENTER_DESCRIPTION = English.Products.TEXT_ENTER_DESCRIPTION,

    } = LanguageData || {};


    useEffect(() => {
        fetchDocuments(1, true);
    }, []);

    const fetchDocuments = useCallback(async (pageNr = 1, isInitialLoad = false) => {
        try {
            if (isInitialLoad) {
                setIsLoading(true);
            } else {
                setIsLoadingMore(true);
            }

            const payload = {
                PageNr: pageNr,
                NrOFRecPerPage: PAGE_SIZE,
                FullSearch: '',
                UserId: currentUserId,
                IncludeRecordNr: true,
                TypeOfObjectReturned: "",
                SearchList: [
                    {
                        AppId: 4, // App Id 4 is for Products
                        AppRecordId: Number(id),
                    }
                ],
                SortList: [
                    {
                        FieldName: "Id",
                        Direction: "desc"
                    }
                ]
            };
            const response = await Postrequestcall(FETCHPRODUCTDOCUMENTS, payload, loginData?.accessToken);

            if (response.data) {
                const newDocuments = response.data.data;
                setNrOfRecords(response.data.nrOfRecords || 0);

                if (pageNr === 1) {
                    setAllDocuments(newDocuments);
                    if (selectedFilter === 0) {
                        setDocuments(newDocuments.slice(0, 5));
                    } else {
                        setDocuments(newDocuments);
                    }
                } else {
                    setAllDocuments(prev => [...prev, ...newDocuments]);
                    setDocuments(prev => [...prev, ...newDocuments]);
                }

                const hasMoreData = newDocuments.length === PAGE_SIZE;
                setHasMore(hasMoreData);

                if (isInitialLoad) {
                    setCurrentPage(1);
                } else {
                    setCurrentPage(pageNr);
                }
            } else {
                if (pageNr === 1) {
                    setDocuments([]);
                    setAllDocuments([]);
                }
            }

            setIsLoading(false);
            setIsLoadingMore(false);
        } catch (error) {
            console.error('Error fetching documents:', error);
            setIsLoading(false);
            setIsLoadingMore(false);
            if (pageNr === 1) {
                setDocuments([]);
                setAllDocuments([]);
            }
        }
    }, [id, loginData, selectedFilter, currentUserId]);


    const loadMoreDocuments = useCallback(() => {
        if (selectedFilter === 1 && !isLoadingMore && hasMore) {
            const nextPage = currentPage + 1;
            fetchDocuments(nextPage, false);
        }
    }, [currentPage, isLoadingMore, hasMore, selectedFilter, fetchDocuments]);

    const refreshDocuments = useCallback(() => {
        fetchDocuments(1, true);
    }, [fetchDocuments]);


    const formatFileSize = (bytes) => {
        if (!bytes) return '0 B';
        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
    };


    const getFileIcon = (type) => {
        if (type?.includes('pdf')) return <PictureAsPdf />;
        if (type?.includes('word') || type?.includes('document')) return <Description />;
        if (type?.includes('image') || type?.includes('jpg') || type?.includes('jpeg') || type?.includes('png')) return <Image />;
        if (type?.includes('video') || type?.includes('mp4')) return <VideoFile />;
        return <InsertDriveFile />;
    };

    const getFileColor = (type) => {
        if (type?.includes('pdf')) return '#e74c3c';
        if (type?.includes('word') || type?.includes('document')) return '#2980b9';
        if (type?.includes('image')) return '#27ae60';
        if (type?.includes('video')) return '#9b59b6';
        return '#95a5a6';
    };

    const handleDocumentPick = useCallback(async () => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.pdf,.doc,.docx,image/*,video/*';

        input.onchange = (e) => {
            const file = e.target.files?.[0];
            if (file) {
                setSelectedFile({
                    uri: URL.createObjectURL(file),
                    name: file.name,
                    type: file.type,
                    size: file.size,
                    file: file
                });
            }
        };

        input.click();
    }, []);

    const handleSave = useCallback(async () => {
        if (!selectedFile) {
            setSnackbar({ open: true, message: TEXT_PLEASE_SELECT_FILE, severity: 'error' });
            return;
        }
        if (!fileDescription.trim()) {
            setShowDescriptionError(true);
            return;
        }

        try {
            setIsUploading(true);
            const formData = new FormData();
            formData.append('UserId', currentUserId);
            formData.append("AppId", 4); // App Id 4 is for Products
            formData.append('AppRecordId', id);
            formData.append('FileName', selectedFile.file);
            formData.append('ModifiedBy', currentUserId);
            formData.append('Description', fileDescription);

            await Fileuploadrequestcall(
                SAVE_USER_DOCUMENTS,
                formData,
                loginData?.accessToken
            );

            setSelectedFile(null);
            setFileDescription('');
            setShowDescriptionError(false);
            refreshDocuments();
            setSnackbar({ open: true, message: TEXT_FILE_SAVED_SUCCESS, severity: 'success' });
        } catch (error) {
            console.error('Error saving file:', error);
            setSnackbar({ open: true, message: TEXT_FAILED_TO_SAVE_FILE, severity: 'error' });
        } finally {
            setIsUploading(false);
        }
    }, [selectedFile, fileDescription, currentUserId, id, loginData, refreshDocuments]);


    const handleRemoveFile = useCallback(() => {
        if (selectedFile?.uri) {
            URL.revokeObjectURL(selectedFile.uri);
        }
        setSelectedFile(null);
        setFileDescription('');
        setShowDescriptionError(false);
    }, [selectedFile]);

    const handleFilterChange = useCallback((event, newValue) => {
        if (newValue === selectedFilter) return;

        setIsTabSwitching(true);
        setSelectedFilter(newValue);

        setTimeout(() => {
            if (newValue === 0) {
                setDocuments(allDocuments.slice(0, 5));
            } else {
                setDocuments(allDocuments);
            }
            setIsTabSwitching(false);
        }, 200);
    }, [allDocuments, selectedFilter]);

    const handleFilePress = (item) => {
        setSelectedFileDetails(item);
        setFileDetailsModalOpen(true);
    }


    const renderFileItem = (item) => (
        <Card key={item?.id} >
            <ListItem disablePadding>
                <ListItemButton onClick={() => handleFilePress(item)} >
                    <ListItemIcon>
                        <Avatar sx={{ bgcolor: `${accentColor}20`, color: accentColor }}>
                            {getFileIcon(item.fileType)}
                        </Avatar>
                    </ListItemIcon>
                    <ListItemText
                        primary={
                            <Typography
                                variant="subtitle1"
                                fontWeight={600}
                                sx={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 1,
                                    WebkitBoxOrient: 'vertical'
                                }}
                            >
                                {item.fileName}
                            </Typography>
                        }
                        secondary={
                            <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{
                                    mt: 0.5,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical'
                                }}
                            >
                                {item.description}
                            </Typography>
                        }
                    />
                    <ArrowForwardIos sx={{ fontSize: 16, color: 'text.secondary' }} />
                </ListItemButton>
            </ListItem>
            {item.fileType?.includes('image') && item.fileUrl && (
                <Box sx={{ px: 2, pb: 2 }}>
                    <img
                        src={item.fileUrl}
                        alt={item.fileName}
                        style={{ width: '100%', height: 200, objectFit: 'contain', borderRadius: 8 }}
                    />
                </Box>
            )}
            {item.fileType?.includes('video') && item.fileUrl && (
                <Box sx={{ px: 2, pb: 2, bgcolor: 'black', borderRadius: 1 }}>
                    <video
                        src={item.fileUrl}
                        controls
                        style={{ width: '100%', height: 300 }}
                    />
                </Box>
            )}
            <Divider />
        </Card>
    );

    if (isLoading && documents.length === 0) {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', py: 8 }}>
                <CircularProgress sx={{ color: accentColor }} />
                <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                    {TEXT_LOADING_DOCEMENTS}
                </Typography>
            </Box>
        );
    }
    return (
        <Box className="main-content-card-list">
            {/* Upload Section */}
            <Paper elevation={0}>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        p: 2,
                        cursor: 'pointer'
                    }}
                    onClick={() => setIsExpanded(prev => !prev)}
                >
                    <Typography variant="h6" fontWeight={700}>
                        {TEXT_UPLOAD_FILE}
                    </Typography>
                    <IconButton size="small">
                        {isExpanded ? <ExpandMore /> : <ExpandLess />}
                    </IconButton>
                </Box>

                <Collapse in={isExpanded}>
                    <Box sx={{ px: 2, pb: 2 }}>
                        {selectedFile ? (
                            <Paper
                                variant="outlined"
                                sx={{
                                    p: 2,
                                    mb: 2,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1 }}>
                                    <Avatar sx={{ bgcolor: `${getFileColor(selectedFile.type)}20`, color: getFileColor(selectedFile.type) }}>
                                        {getFileIcon(selectedFile.type)}
                                    </Avatar>
                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                        <Typography variant="subtitle1"
                                            fontWeight={600}
                                            sx={{
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                display: '-webkit-box',
                                                WebkitLineClamp: 1,
                                                WebkitBoxOrient: 'vertical'
                                            }}
                                        >
                                            {selectedFile.name}
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary">
                                            {formatFileSize(selectedFile.size)}
                                        </Typography>
                                    </Box>
                                </Box>
                                <IconButton onClick={handleRemoveFile} disabled={isUploading} color="error">
                                    <Close />
                                </IconButton>
                            </Paper>
                        ) : (
                            <Button
                                fullWidth
                                variant="outlined"
                                startIcon={<CloudUpload />}
                                onClick={handleDocumentPick}
                                disabled={isUploading}
                                color="primary"
                                sx={{ mb: 2, height: 48, textTransform: 'none' }}
                            >
                                {TEXT_CHOOSE_FILE}
                            </Button>
                        )}

                        <TextField
                            fullWidth
                            multiline
                            rows={3}
                            placeholder={TEXT_ADD_DESC_PLACEHOLDER}
                            value={fileDescription}
                            onChange={(e) => {
                                setFileDescription(e.target.value);
                                if (showDescriptionError && e.target.value.trim()) {
                                    setShowDescriptionError(false);
                                }
                            }}
                            disabled={isUploading}
                            required
                            error={showDescriptionError}
                            helperText={showDescriptionError ? TEXT_ENTER_DESCRIPTION : ''}
                            sx={{
                                mb: 2,
                                '& .MuiOutlinedInput-root': {
                                    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#d32f2f',
                                        borderWidth: '2px'
                                    }
                                }
                            }}
                        />

                        {selectedFile && (
                            <Button
                                fullWidth
                                variant="contained"
                                startIcon={isUploading ? <CircularProgress size={20} color="inherit" /> : <CloudUpload />}
                                onClick={handleSave}
                                disabled={isUploading}
                                sx={{
                                    bgcolor: accentColor,
                                    '&:hover': { bgcolor: accentColor, opacity: 0.9 },
                                    height: 48,
                                    textTransform: 'none',
                                    fontWeight: 600
                                }}
                            >
                                {isUploading ? TEXT_UPLOADING : TEXT_UPLOAD_FILE}
                            </Button>
                        )}
                    </Box>
                </Collapse>
            </Paper>

            {/* Documents List Section */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2, mb: 2 }}>
                <Typography variant="h6" fontWeight={700}>
                    {TEXT_DOCEMENTS} ({nrOfRecords})
                </Typography>
                <IconButton onClick={refreshDocuments} disabled={isLoading} sx={{ color: accentColor }}>
                    <Refresh />
                </IconButton>
            </Box>

            {/* Tab Navigator */}
            <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
                <Tabs
                    value={selectedFilter}
                    onChange={handleFilterChange}
                    TabIndicatorProps={{ style: { backgroundColor: accentColor } }}
                >
                    <Tab
                        label={TEXT_RECENTS}
                        sx={{
                            textTransform: 'none',
                            fontWeight: 'bold',
                            '&.Mui-selected': { color: accentColor }
                        }}
                    />
                    <Tab
                        label={TEXT_TECHNICAL_DOCUMENTS}
                        sx={{
                            textTransform: 'none',
                            fontWeight: 'bold',
                            '&.Mui-selected': { color: accentColor }
                        }}
                    />
                </Tabs>
            </Box>

            {/* Document List */}
            {isTabSwitching ? (
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 8 }}>
                    <CircularProgress sx={{ color: accentColor }} size={32} />
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                        {TEXT_LOADING_DOCEMENTS}
                    </Typography>
                </Box>
            ) : documents.length === 0 ? (
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 8 }}>
                    <FolderOpen sx={{ fontSize: 60, color: 'text.disabled' }} />
                    <Typography variant="h6" fontWeight={600} sx={{ mt: 2 }}>
                        {TEXT_NO_DOCUMENTS}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {TEXT_UPLOAD_DOCUMENTS_PLACEHOLDER}
                    </Typography>
                </Box>
            ) : (
                <InfiniteScroll
                    dataLength={documents.length}
                    next={async () => {
                        loadMoreDocuments();
                    }}
                    hasMore={true}
                    loader={
                        isLoadingMore && selectedFilter === 1 && (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, py: 3 }}>
                                <CircularProgress size={20} sx={{ color: accentColor }} />
                                <Typography variant="body2" color="text.secondary">
                                    {TEXT_LOADING_MORE_DOCEMENTS}
                                </Typography>
                            </Box>
                        )
                    }
                    scrollableTarget={scrollId}>
                    <List disablePadding>
                        {documents.map(renderFileItem)}
                    </List>
                </InfiniteScroll>

            )}

            {/* File Details Modal */}
            {
                fileDetailsModalOpen && selectedFileDetails != null && (
                    <ProductDocumentDetailModal
                        open={fileDetailsModalOpen}
                        onClose={() => setFileDetailsModalOpen(false)}
                        document={selectedFileDetails}
                    />
                )
            }

            {/* Snackbar for notifications */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setSnackbar({ ...snackbar, open: false })}
                    severity={snackbar.severity}
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Box>
    )
}
